/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Handlebars additional helpers
define('global/HandlebarsUtils.Custom',[
    'jquery',
    'lodash',
    './Logger',
    './UI/all',
    'handlebars',
    'plugins/accounting.min'
], function ($, _, Logger, UI, Handlebars, accounting) {
    Logger.debug('Loading Custom Handlebars Helpers.');

    var cfg = window.RocConfig;

    var packagePath = cfg.cms.packagePath;
    var cdnUrl = cfg.ht.imageCdn;


    Handlebars.registerHelper('htProductImage', function (product) {
        // if the cdn url is configured and the product has the image attribute, pull from there

        //if (cdnUrl && product && product.customFields && product.customFields['primary_Image_Large']) {
        //    var primaryImageAttrib = product.customFields['primary_Image_Large'];
            if (product && product.customFields && product.customFields['primary_Image']) {
                var primaryImageAttrib = product.customFields['primary_Image'];
            var firstValue = primaryImageAttrib[0];

            if (firstValue && firstValue.value) {
               // return cdnUrl + firstValue.value;
                return firstValue.value;
            }
        }

        // otherwise return the NA image
        return packagePath + '/assets/images/na-images/na-l.svg';
    });

    Handlebars.registerHelper('htLoggedIn', function (options) {
        var Users = require('modules/User/Users');

        if (Users.isLoggedIn()) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    /**
     * HELPER: htFormatCurrency
     *
     * Usage: 
     *  1) display currency on property
     *  {{htFormatCurrency price}}
     *  
     *  2) display currency on calculated property (using math helper)
     *  {{htFormatCurrency (math price "*" quantity)}}
     *
     *  3) display currency or label when value is 0
     *  {{htFormatCurrency shipping freeLabel="Free"}}
     */
    Handlebars.registerHelper('htFormatCurrency', function (value, options) {
        var precision = options.hash.precision || 2;

        if (options.hash.freeLabel && !Boolean(value)) {
            return options.hash.freeLabel;
        } else {
            return accounting.formatMoney(value, '$', precision);
        }
    });

    return Handlebars;
});

